import { Module } from "@baseline/runtime/module";
import * as webpack from "@baseline/runtime/webpack/module";

const path = (!process.env.WEBPACK) && require("path") as typeof import("path");


export interface StyleModule extends webpack.Module 
{
    moduleType: "style";
    exports:
    {
        styles: Styles;
        styleSource: string;
    };
}


export namespace StyleModule
{
    export function isStyleModule(module: Module): module is StyleModule;
    export function isStyleModule(module: StyleModule): module is StyleModule
    {
        return module?.moduleType == "style";
    }

    export function getStyleModules(): StyleModule[]
    {
        const modules = Module.getModules();
        const styleModules = modules.filter(isStyleModule);
        // styleModules.sort(
        //     (first, second) => first.id.localeCompare(second.id)
        // );
        return styleModules;
    }

    export function getStyleModuleId(module: Module): string
    {
        if (process.env.WEBPACK)
        {
            return module.id;
        }
        else
        {
            const relativePath = path.relative(basePath, module.id);
            let id = "./" + relativePath.replace(/\\/g, "/");
            return id;
        }
    }


    let basePath: string;
    if (!process.env.WEBPACK)
        basePath = process.cwd();
}


export type Styles = Record<string, string>;
